<template>
  <div>
    <div class="page val">
      <div class="top">
        <div>
          <div class="icon"><i class="fa-solid fa-cart-shopping"></i></div>
          <div class="title"><span>Valores</span></div>
        </div>
        <div class="actions">
          <div class="search-wrap">
            <i class="fa-solid fa-magnifying-glass"></i>
            <input type="text" name="search" v-model="search" @change="getMob(cat)" placeholder="Pesquisar...">
          </div>
          <button :disabled="disableP" @click="getMob(cat, prev)"><i class="fa-solid fa-angle-left"></i>
          </button>
          <button :disabled="disableN" @click="getMob(cat, next)"><i class="fa-solid fa-angle-right"></i>
          </button>
        </div>
      </div>
      <div class="val-cat">
        <div class="btn" :class="{active: cat === 0}" @click="() => {search = ''; getMob(0);}">Todos</div>
        <div class="btn" v-for="vc in val_cat" :key="vc.id" @click="() => {search = ''; getMob(vc.id);}" :class="{active: vc.id === cat}">
          {{ vc.category }}
        </div>
      </div>
      <div class="content-val tip">
        <template v-if="loading">
          <div class="mob sk" v-for="i in 9" :key="i">
            <div class="topItem">
              <Sk w="64px" h="36px" rounded="rounded-tl-xl" extra="!rounded-tr-none !rounded-br-none !rounded-bl-none" />
              <div class="right">
                <Sk w="26px" h="26px" rounded="rounded-full" />
                <Sk w="26px" h="26px" rounded="rounded-full" />
                <Sk w="26px" h="26px" rounded="rounded-full" />
              </div>
            </div>
            <Sk w="70px" h="70px" extra="mx-auto my-4" rounded="rounded-lg" />
            <Sk w="100%" h="54px" rounded="rounded-b-xl" extra="!rounded-t-none" />
          </div>
        </template>
        <div class="mob" v-else v-for="(m, index) in mobs" :key="index">
          <div class="topItem">
            <div class="preco">
              <div class="icon"></div>
              <span>{{ m.preco }}</span>
            </div>
            <div class="right">
              <div class="stats" v-if="m.stats === '1'"><i class="fa-solid fa-arrow-trend-up"></i></div>
              <div class="stats" v-else-if="m.stats === '2'"><i class="fa-solid fa-arrow-trend-down"></i></div>
              <div class="stats" v-else><i class="fa-solid fa-grip-lines"></i></div>

              <div class="calc add" @click="store.addCalc({data: m, qty: 1})"><i
                class="fa-solid fa-plus"></i></div>
              <div class="calc rem" @click="store.removeCalc({id: m.id, qty: 1})"><i
                class="fa-solid fa-minus"></i></div>
            </div>
          </div>
          <div class="mobi" @click="setShowMod(m.id)" :style="{backgroundImage: 'url('+m.icon+')'}"></div>
          <div class="name nobr" @click="setShowMod(m.id)">{{ m.mob }}</div>
        </div>
      </div>
    </div>
    <Transition name="slide-fade">
      <ModInfoVal v-if="showMod" :id="mob_id" @close="setShowMod()" />
    </Transition>
    <Transition name="slide-fade">
      <ValoresCalc />
    </Transition>
  </div>
</template>

<script setup>

import { getMobs, getValCat } from '@/services/api.js'
import { useStore } from '@/stores/index.js'
import ModInfoVal from '@/components/modals/valores.vue'
import ValoresCalc from '@/components/modals/calcValores.vue'
import Sk from '@/components/usefulness/Sk.vue'
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const store = useStore()
const route = useRoute()

const disableN = ref(false)
const disableP = ref(false)
const prev = ref(0)
const next = ref(0)
const search = ref(route.query?.s ?? '')
const val_cat = ref([])
const mobs = ref([])
const loading = ref(true)
const showMod = ref(false)
const cat = ref(0)
const mob_id = ref(0)

async function getMob(catTemp, paga = 1) {
  loading.value = true
  cat.value = catTemp
  const data = await getMobs({ cat: catTemp, pag: paga, s: search.value })
  mobs.value = data.valores
  prev.value = data.prev
  next.value = data.next
  disableP.value = parseInt(data.prev) === 0
  disableN.value = data.next === 0
  loading.value = false
}

async function getCat() {
  val_cat.value = await getValCat()
}

function setShowMod(i) {
  mob_id.value = i
  showMod.value = !showMod.value
}

getMob(cat.value, 1)
getCat()

watch(() => route.query?.s, (newRoute) => {
  search.value = newRoute
  getMob(cat.value, 1)
})

</script>

<style scoped>
.val .top {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.val .top .icon {
  background-image: none;
  background-color: #2FC145;
}

.val .top .actions {
  width: 34%;
  display: flex;
  justify-content: space-between;
}

.val .top .actions .search-wrap {
  position: relative;
}

.val .top .actions .search-wrap > i {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 13px;
  pointer-events: none;
}

.val .top .actions .search-wrap > input {
  float: left;
  width: 170px;
  height: 36px;
  background-color: #fff;
  border-radius: 20px;
  padding-left: 36px;
}

@media (max-width: 1199px) {
  .val .top {
    flex-wrap: wrap;
    gap: 8px;
  }

  .val .top .actions {
    width: 100%;
    flex-wrap: wrap;
    gap: 8px;
  }

  .val .top .actions .search-wrap {
    flex: 1;
    min-width: 0;
  }

  .val .top .actions .search-wrap > input {
    width: 100%;
  }

  .val .content-val {
    flex-direction: column;
  }

  .val .content-val .mob {
    width: 100% !important;
  }
}

.val .top .actions button {
  float: left;
  width: 36px;
  height: 36px;
  border-radius: 30px;
  background-color: #D7DDE4;
  font-size: 14px;
  text-align: center;
  line-height: 36px;
  color: #BDC4CD;
}

.val .val-cat {
  float: left;
  width: 100%;
  height: auto;
  margin-top: 20px;
}

.val .val-cat .btn {
  float: left;
  width: auto;
  height: 36px;
  background-color: #E7EBF0;
  border-radius: 20px;
  text-align: center;
  line-height: 36px;
  font-size: 14px;
  font-weight: 600;
  color: #505F6C;
  padding: 0 16px;
  margin: 6px 0 0 6px;
  user-select: none;
  cursor: pointer;
  transition: all .3s ease-in;
}

.val .val-cat .btn:hover,
.val .val-cat .btn.active {
  background-color: #2FC145;
  color: #fff;
}

.val .content-val {
  float: left;
  width: 100%;
  height: auto;
  display: flex;
  flex-flow: wrap;
  justify-content: space-around;
  margin-top: 20px;
}

.val .content-val .mob {
  position: relative;
  width: calc(33% - 10px);
  height: auto;
  background-color: #FBFCFD;
  border-radius: 12px;
  margin-top: 8px;
  transition: all .3s ease-in-out;
}

.val .content-val .mob.sk {
  background-color: #fff;
  overflow: hidden;
}

.val .content-val .mob:hover {
  background-color: #2DB742;
}

.val .content-val .mob .topItem {
  display: flex;
  justify-content: space-between;
}

.val .content-val .mob .preco {
  width: auto;
  height: 36px;
  padding: 0 12px;
  background-color: #F7BD14;
  border-radius: 12px 0 12px 0;
  text-align: center;
  line-height: 36px;
  font-size: 13px;
  font-weight: 800;
  color: rgba(0, 0, 0, .45);
  transition: all .3s ease-in-out;
  user-select: none;
}

.val .content-val .mob:hover .preco {
  background-color: #fff;
}

.val .content-val .mob .preco span {
  float: left;
  width: auto;
  height: 100%;
  margin: 0 0 0 8px;
}

.val .content-val .mob .preco .icon {
  float: left;
  width: 15px;
  height: 15px;
  background-image: url('../assets/asinha.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin: 10px 0 0 0;
}

.val .content-val .mob .right {
  position: relative;
  right: 8px;
  top: 8px;
  display: flex;
  justify-content: space-between;
  width: 40%;
  height: 30px;
}

.val .content-val .mob .stats {
  float: right;
  width: 30px;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  color: #444;
  text-align: center;
  transition: all .3s ease-in-out;
}

.val .content-val .mob .stats i.fa-arrow-trend-up {
  color: #2EC044;
}

.val .content-val .mob .stats i.fa-arrow-trend-down {
  color: #FF4040;
}

.val .content-val .mob .stats i.fa-grip-lines {
  color: #0D93C6;
}

.val .content-val .mob:hover .stats i {
  color: #fff;
}

.val .content-val .mob .calc {
  width: 26px;
  height: 26px;
  background-color: #2DB742;
  border-radius: 30px;
  text-align: center;
  line-height: 26px;
  color: #fff;
  font-size: 11px;
  transition: all .3s ease;
  cursor: pointer;
}

.val .content-val .mob:hover .calc {
  background-color: #fff;
  color: #2DB742;
}

.val .content-val .mob .mobi {
  float: left;
  width: 100%;
  height: 100px;
  margin: 6px 0;
  background-position: center;
  background-repeat: no-repeat;
}

.val .content-val .mob .name {
  float: left;
  width: 100%;
  height: 54px;
  background-color: #fff;
  border-radius: 0 0 12px 12px;
  line-height: 54px;
  text-align: center;
  font-weight: 500;
  font-size: 15px;
  box-shadow: 0 -1px 4px rgba(0, 0, 0, .15);
  transition: all .3s ease-in-out;
  padding: 0 10px;
}

.val .content-val .mob:hover .name {
  background-color: #2FC145;
  color: #fff;
}

</style>
